﻿import * as paths from '../utils/paths';
import * as layerTypes from '../utils/layerTypes';
import * as eventTypes from '../utils/eventTypes';
import * as defaults from '../utils/defaults';
import * as styleTypes from '../utils/style/styleTypes';

export default class LayerSettingsHandler {
    constructor(rootURL, mapId, resourcesHandler, classId) {
        this.rootURL = rootURL;
        this.mapId = mapId;
        this.resourcesHandler = resourcesHandler;
        this.layers = {};
        this.styles = {};
        this.classId = classId;
        this.legendLayerSettingsSwitchPrefix = 'legend-layer-settings-switch-' + this.classId + '-';
        this.legendLayerDeletePrefix = 'legend-layer-delete-' + this.classId + '-';
        this.legendLayerAddPrefix = 'legend-layer-add-' + this.classId + '-';
        this.pendingChanges = false;
        this.featureHandler = null;
        sessionStorage.removeItem('xp_analysis');
        this._registerNotificationHandlers();
    }

    load() {
        return new Promise((resolve, reject) => {
            $.ajax({
                type: "GET",
                url: this.rootURL + paths.MAP_LAYERS_SETTINGS_URL + this.mapId,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    if (result != null) {
                        this.layers = result.Layers;
                        this._setLayersId(this.layers);
                        this.styles = result.Styles;
                        this._handleStorage(this.layers);
                    } else {
                        this.layers = [];
                    }
                    resolve();
                },
                error: (e) => {
                    reject(e);
                }
            });
        });
    }

    _setLayersId(layers) {
        layers.forEach(layer => {
            if (layer.Id == 0 && layer.Name && layer.Name != '') {
                layer.Id = layer.Name;
            }
            if (layer.Type == layerTypes.GROUP && layer.Items != null) {
                this._setLayersId(layer.Items);
            }
        });
    }
    _handleStorage(layers) {
        layers.forEach(layer => {
            this._handleSorageLayer(layer);
        });
    }

    _handleSorageLayer(layer) {
        if (layer.Type == layerTypes.GROUP && layer.Items != null) {
            this._handleStorage(layer.Items);
        } else {
            let storageLayer = this._getStorageLayer(layer.Id, layer.GeneralActions);

            if (storageLayer != null) {
                if (storageLayer.Charts != null) {
                    layer.Charts = storageLayer.Charts;
                }
            }
        }
    }

    loadExternalLayer(id) {
        this.removeExternalLayer(id, true);
        $.ajax({
            type: "GET",
            url: this.rootURL + paths.MAP_EXTERNAL_LAYERS_SETTINGS_URL.replace("{0}", id).replace("{1}", this.mapId),
            async: true,
            contentType: "application/json; charset=utf-8",
            success: (result) => {
                if (result.Styles) {
                    let styleIds = Object.keys(result.Styles);

                    styleIds.forEach((styleId) => {
                        this.styles[styleId] = result.Styles[styleId];
                    });
                }

                if (result.Layers && result.Layers.length > 0) {
                    result.Layers.forEach(layer => {
                        this._addLayerGroup(null, this.layers, layer);
                    });
                }
            },
            error: (e) => {
            }
        });
    }
    _addLayerGroup(parentId, layers, layer) {
        if (layer.Type == layerTypes.GROUP) {
            const layerId = layer.Id == 0 ? layer.Name : layer.Id;
            var group = this._findLayer(this.layers, layerId);
            //var group = null;
            // for (const item of layers) {
            //     if (item.Id == layerId) {
            //         group = item;
            //         break;
            //     }
            // }
            if (group == null) {
                group = {
                    Type: layerTypes.GROUP,
                    Id: layerId,
                    Title: layer.Title,
                    VisibleByDefault: layer.VisibleByDefault,
                    Items: []
                };
                this.addLayer(group, 0, parentId);
            }
            for (const sublayer of layer.Items) {
                this._addLayerGroup(group.Id, group.Items, sublayer);
            }
        }
        else {
            this.addLayer(layer, 0, parentId);
        }
    }
    getLayerBbox(id, srid) {
        let filter = this.getLayerSettings(id).Filters;
        return new Promise((resolve, reject) => {
            let url = paths.MAP_LAYER_BBOX_URL;
            url = url.replaceAll('{0}', this.mapId);
            url = url.replaceAll('{1}', id);
            url = url.replaceAll('{2}', srid);

            if (filter == null) {
                filter = {};
            }

            url = url.replaceAll('{3}', JSON.stringify(filter));
            showLoadingPanel();
            $.ajax({
                type: "GET",
                url: this.rootURL + url,
                async: true,
                contentType: "application/json; charset=utf-8",
                success: (result) => {
                    hideLoadingPanel();
                    resolve(result);
                },
                error: (e) => {
                    hideLoadingPanel();
                    reject(e);
                }
            });
        });
    }

    removeExternalLayer(id, keepEmptyParents) {
        let layers = this.getExternalLayerSettingsByEntityId(id);

        if (layers.length > 0) {
            layers.forEach(layer => {
                var parent = this._getLayerParent(null, layer);
                if (parent) {
                    this._removeLayer(parent.Items, layer);
                }
                else {
                    this._removeLayer(this.layers, layer);
                }
                
                $('.legend-layer-wrapper[data-id="' + layer.Id + '"]').remove();
                $('.legend-layer-classifications[data-id="' + layer.Id + '"]').remove();
                $event.notify(eventTypes.LAYER_REMOVED, { ids: [layer.Id] }, this, this.classId);

                if (!keepEmptyParents) {
                    while (parent && isNaN(parent.Id) && parent.Items && parent.Items.length == 0) {
                        var item = parent;
                        parent = this._getLayerParent(null, item);
                        this._removeLayer(this.layers, item);
                        $('.legend-layer-wrapper[data-id="' + item.Id + '"]').remove();
                        $('.legend-layer-classifications[data-id="' + item.Id + '"]').remove();
                        $event.notify(eventTypes.LAYER_REMOVED, { ids: [item.Id] }, this, this.classId);
                    }
                }
            });
        }
    }

    _getLayerParent(parent, layer) {
        var layers = this.layers;
        if (parent) {
            layers = parent.Items;
        }
        for (let i = 0; i < layers.length; i++) {
            if (layers[i].Id == layer.Id) {
                return parent;
            } else if (layers[i].Type == layerTypes.GROUP && layers[i].Items != null) {
                const parent = this._getLayerParent(layers[i], layer);
                if (parent) return parent;
            }
        }

        return null;
    }

    _removeLayer(layers, layer) {
        let idx = 0;
        let found = false;

        for (let i = 0; i < layers.length; i++) {
            if (layers[i].Id == layer.Id) {
                found = true;
                i = layers.length;
            } else if (layers[i].Type == layerTypes.GROUP && layers[i].Items != null) {
                this._removeLayer(layers[i].Items, layer);
                idx++;
            } else {
                idx++;
            }
        }

        if (found) {
            layers.splice(idx, 1);
        }
    }

    getLayerSettingsByName(name) {
        let result = [];

        this._findLayerSettingsByName(result, this.layers, name);

        return result;
    }

    _findLayerSettingsByName(result, layers, name) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Title == name) {
                    result.push(layer);
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    this._findLayerSettingsByName(result, layer.Items, name);
                }
            });
        }
    }

    getLayerSettingsByEntityId(id) {
        let result = [];

        this._findLayerSettingsByEntityId(result, this.layers, id);

        return result;
    }

    _findLayerSettingsByEntityId(result, layers, id) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Entity && layer.Entity.Id == id) {
                    result.push(layer);
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    this._findLayerSettingsByEntityId(result, layer.Items, id);
                }
            });
        }
    }

    getExternalLayerSettingsByEntityId(id) {
        let result = [];

        this._findExternalLayerByEntityId(result, this.layers, id);

        return result;
    }

    _findExternalLayerByEntityId(result, layers, id) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Id < 0 && layer.Entity?.Id == id) {
                    result.push(layer);
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    this._findExternalLayerByEntityId(result, layer.Items, id);
                }
            });
        }
    }

    getLayerSettings(layerId) {
        return this._findLayer(this.layers, layerId);
    }

    getLayerSettingsByField(idField, idExtConn, objectId, ignore, hasSelection) {
        return this._findLayerByGeometryFieldId(this.layers, idField, idExtConn, objectId, ignore, hasSelection);
    }

    getAllLayersByGeometryField(idField, idExtConn) {
        let result = [];
        this._findAllLayersByGeometryFieldId(result, this.layers, idField, idExtConn);

        return result;
    }

    setLayerExtent(layerId, extent) {
        // TO DO
    }

    addConfigForLayer(layer, legend) {
        // DO NOTHING HERE
    }

    addLayer(layer, index, parentId, hide) {
        if (parentId == null) {
            let newLayers = [];

            let layersBefore = this.layers.slice(0, index);

            layersBefore.forEach(layerBefore => {
                newLayers.push(layerBefore);
            });

            newLayers.push(layer);

            let layersAfter = this.layers.slice(index);

            layersAfter.forEach(layerAfter => {
                newLayers.push(layerAfter);
            });

            this.layers = newLayers;
            $event.notify(eventTypes.LAYER_ADDED, { layerId: layer.Id, hide: hide }, this, this.classId);
        } else {
            let parent = this.getLayerSettings(parentId);

            let newLayers = [];
            let layersBefore = parent.Items.slice(0, index);

            layersBefore.forEach(layerBefore => {
                newLayers.push(layerBefore);
            });

            newLayers.push(layer);

            let layersAfter = parent.Items.slice(index);

            layersAfter.forEach(layerAfter => {
                newLayers.push(layerAfter);
            });

            parent.Items = newLayers;
            $event.notify(eventTypes.LAYER_ADDED, { layerId: layer.Id, hide: hide }, this, this.classId);
        }
    }

    _registerNotificationHandlers() {
        $event.register(eventTypes.LAYER_OPACITY_CHANGED, this._getLayerOpacityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_VISIBILITY_CHANGED, this._getLayerVisibilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_ORDER_CHANGED, this._getLayerOrderChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_SELECTABILITY_CHANGED, this._getLayerSelectabilityChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_STYLE_CHANGED, this._getLayerStyleChangedHandler(), this, this.classId);
        $event.register(eventTypes.LAYER_ANALYSIS_ADDED, this._getLayerAnalysisAddedHandler(), this, this.classId);
        $event.register(eventTypes.CHART_ADDED, this._getChartAddedHandler(), this, this.classId);
        $event.register(eventTypes.CHART_REMOVED, this._getChartRemovedHandler(), this, this.classId);
        $event.register(eventTypes.CHART_UPDATED, this._getChartUpdatedHandler(), this, this.classId);
    }

    _getChartRemovedHandler() {
        var handler = (eventName, data, sender) => {
            let layer = this._findLayer(this.layers, data.layerId);

            if (data.chartId != null && layer != null && layer.Charts != null && layer.Charts[data.chartId] != null) {
                delete layer.Charts[data.chartId];

                let storageLayers = {};

                if (localStorage.getItem('mapLayers') != null) {
                    storageLayers = JSON.parse(localStorage.getItem('mapLayers'));

                    if (storageLayers == null) {
                        storageLayers = {};
                    }
                }

                if (storageLayers[this._getCurrentStorageKey()] != null && storageLayers[this._getCurrentStorageKey()][data.layerId] != null && storageLayers[this._getCurrentStorageKey()][data.layerId].Charts != null && storageLayers[this._getCurrentStorageKey()][data.layerId].Charts[data.chartId]) {
                    delete storageLayers[this._getCurrentStorageKey()][data.layerId].Charts[data.chartId];

                    if (Object.keys(storageLayers[this._getCurrentStorageKey()][data.layerId].Charts).length == 0) {
                        delete storageLayers[this._getCurrentStorageKey()][data.layerId].Charts;
                    }
                }

                localStorage.setItem('mapLayers', JSON.stringify(storageLayers));
            }
        };

        return handler;
    }

    _getChartAddedHandler() {
        var handler = (eventName, data, sender) => {
            let layer = this._findLayer(this.layers, data.layerId);

            if (layer != null) {
                layer.Charts[data.chart.id] = data.chart;
                this.pendingChanges = true;
                this._setChartToStorage(data.layerId, data.chart);
            }
        };

        return handler;
    }

    _getChartUpdatedHandler() {
        var handler = (eventName, data, sender) => {
            let layer = this._findLayer(this.layers, data.layerId);

            if (layer != null) {
                layer.Charts[data.chart.id] = data.chart;
                this.pendingChanges = true;
                this._setChartToStorage(data.layerId, data.chart);
            }
        };

        return handler;
    }

    _getStorageLayer(layerId, generalActions) {
        let storageLayers = null;
        let result = null;

        if (localStorage.getItem('mapLayers') != null) {
            storageLayers = JSON.parse(localStorage.getItem('mapLayers'));
        }

        if (storageLayers != null) {
            if (storageLayers[this._getCurrentStorageKey()] != null) {
                if (storageLayers[this._getCurrentStorageKey()][layerId] != null) {
                    result = storageLayers[this._getCurrentStorageKey()][layerId];
                }
            }
        }

        if (generalActions != null && generalActions.length > 0) {
            let chartActions = [];
            generalActions.forEach(generalAction => {
                if (generalAction.SubType == 'STATISTICS') {
                    chartActions.push(generalAction);
                }
            });

            if (chartActions.length > 0) {
                if (result == null) {
                    result = {
                        Charts: {}
                    };
                }

                if (result.Charts == null) {
                    result.Charts = {};
                }

                chartActions.forEach(chartAction => {
                    if (chartAction.Content != null && chartAction.Content.trim().length > 0) {
                        let chartContent = JSON.parse(chartAction.Content);

                        let chartConfig = {
                            id: chartAction.Id,
                            title: chartAction.Text,
                            type: chartContent.type,
                            condition: chartContent.condition
                        }

                        if (chartContent.type == 'Card') {
                            chartConfig.field = chartContent.field;
                            chartConfig.aggregation = chartContent.aggregation;
                            chartConfig.backgroundColor = chartContent.backgroundColor;
                            chartConfig.fontColor = chartContent.fontColor;
                            chartConfig.titleFontSize = chartContent.titleFontSize;
                            chartConfig.valueFontSize = chartContent.valueFontSize;
                        }

                        if (chartContent.type == 'Pie') {
                            chartConfig.categoryField = chartContent.categoryField;
                            chartConfig.valueField = chartContent.valueField;
                            chartConfig.aggregation = chartContent.aggregation;
                            chartConfig.maxSlices = chartContent.maxSlices;
                            chartConfig.backgroundColor = chartContent.backgroundColor;
                            chartConfig.fontColor = chartContent.fontColor;
                            chartConfig.titleFontSize = chartContent.titleFontSize;
                            chartConfig.labelFontSize = chartContent.labelFontSize;
                            chartConfig.labelType = chartContent.labelType;
                            chartConfig.colorPalette = chartContent.colorPalette;
                            chartConfig.customColors = chartContent.customColors;
                        }

                        if (chartContent.type == 'Bubble') {
                            chartConfig.xField = chartContent.xField;
                            chartConfig.yField = chartContent.yField;
                            chartConfig.sizeField = chartContent.sizeField;
                            chartConfig.splitByField = chartContent.splitByField;
                            chartConfig.maxBubbleSize = chartContent.maxBubbleSize;
                            chartConfig.nullHandling = chartContent.nullHandling;
                            chartConfig.colorPalette = chartContent.colorPalette;
                            chartConfig.customColors = chartContent.customColors;
                            chartConfig.backgroundColor = chartContent.backgroundColor;
                            chartConfig.fontColor = chartContent.fontColor;
                            chartConfig.titleFontSize = chartContent.titleFontSize;
                            chartConfig.labelFontSize = chartContent.labelFontSize;
                        }

                        if (chartContent.type == 'Line' || chartContent.type == 'Bar') {
                            chartConfig.xField = chartContent.xField;
                            chartConfig.seriesMode = chartContent.seriesMode || 'manual';
                            chartConfig.series = chartContent.series;
                            chartConfig.splitByField = chartContent.splitByField;
                            chartConfig.splitValueField = chartContent.splitValueField;
                            chartConfig.splitAggregation = chartContent.splitAggregation;
                            chartConfig.colorPalette = chartContent.colorPalette;
                            chartConfig.customColors = chartContent.customColors;
                            chartConfig.sortOrder = chartContent.sortOrder;
                            chartConfig.backgroundColor = chartContent.backgroundColor;
                            chartConfig.fontColor = chartContent.fontColor;
                            chartConfig.titleFontSize = chartContent.titleFontSize;
                            chartConfig.labelFontSize = chartContent.labelFontSize;
                        }

                        if (chartContent.type == 'Grid') {
                            chartConfig.columns = chartContent.columns;
                            chartConfig.groupBy = chartContent.groupBy;
                            chartConfig.rowsPerPage = chartContent.rowsPerPage;
                            chartConfig.rowLimit = chartContent.rowLimit;
                            chartConfig.density = chartContent.density;
                            chartConfig.stickyFirstColumn = chartContent.stickyFirstColumn;
                            chartConfig.backgroundColor = chartContent.backgroundColor;
                            chartConfig.fontColor = chartContent.fontColor;
                            chartConfig.titleFontSize = chartContent.titleFontSize;
                        }

                        if (result.Charts[chartConfig.id] == null) {
                            result.Charts[chartConfig.id] = chartConfig;
                        }
                    }
                });
            }
        }

        return result;
    }

    _setChartToStorage(layerId, chartConfig) {
        let storageLayers = {};

        if (localStorage.getItem('mapLayers') != null) {
            storageLayers = JSON.parse(localStorage.getItem('mapLayers'));

            if (storageLayers == null) {
                storageLayers = {};
            }
        }

        if (storageLayers[this._getCurrentStorageKey()] == null) {
            storageLayers[this._getCurrentStorageKey()] = {};
        }

        if (storageLayers[this._getCurrentStorageKey()][layerId] == null) {
            storageLayers[this._getCurrentStorageKey()][layerId] = {};
        }

        if (storageLayers[this._getCurrentStorageKey()][layerId].Charts == null) {
            storageLayers[this._getCurrentStorageKey()][layerId].Charts = {};
        }

        storageLayers[this._getCurrentStorageKey()][layerId].Charts[chartConfig.id] = chartConfig;

        localStorage.setItem('mapLayers', JSON.stringify(storageLayers));
    }

    _getCurrentStorageKey() {
        if (xapp != null && xapp.currentApp != null) {
            return xapp.currentApp + '_' + this.mapId;
        } else {
            return '_' + this.mapId;
        }
    }

    _getLayerOpacityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layer = this._findLayer(this.layers, data.layerId);

                if (layer != null) {
                    layer.Opacity = data.opacity;
                    this.pendingChanges = true;
                }
            }
        };

        return handler;
    }

    _getLayerVisibilityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layer = this._findLayer(this.layers, data.layerId);

                if (layer != null) {
                    layer.VisibleByDefault = data.visible;
                    this.pendingChanges = true;

                    if (layer.Id < 0) {
                        let url = this.rootURL + paths.HIDE_EXTERNAL_LAYER + layer.Id;

                        if (data.visible) {
                            url = this.rootURL + paths.SHOW_EXTERNAL_LAYER + layer.Id;
                        }

                        $.ajax({
                            type: "POST",
                            url: url,
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            success: (result) => {
                            },
                            error: (e) => {
                            }
                        });
                    }
                }
            }
        };

        return handler;
    }

    _getLayerOrderChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let hierarchy = data.layers;
                this._reconstructLayerTree(hierarchy);
                this.layers = hierarchy;
                this.pendingChanges = true;
            }
        };

        return handler;
    }

    _getLayerSelectabilityChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null) {
                let layer = this._findLayer(this.layers, data.layerId);

                if (layer != null) {
                    layer.Selectable = data.selectable;
                    this.pendingChanges = true;
                }
            }
        };

        return handler;
    }

    _getLayerStyleChangedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null && data.layerId != null) {
                let layer = this._findLayer(this.layers, data.layerId);

                if (layer != null) {
                    layer.IdDefaultStyle = data.styles.defaultStyle;
                    layer.IdHighlightStyle = data.styles.highlightStyle;
                    layer.IdSelectStyle = data.styles.selectStyle;
                    this.pendingChanges = true;
                }
            }
        };

        return handler;
    }

    _getLayerAnalysisAddedHandler() {
        var handler = (eventName, data, sender) => {
            if (data != null && data.id != null) {
                let analysis = JSON.parse(sessionStorage.getItem('xp_analysis'))[data.id];

                let layer = {
                    Id: data.id,
                    Title: analysis.layerName,
                    Interpretation: layerTypes.NATIVE_XP,
                    Format: 'application/json',
                    Entity: analysis,
                    LoadingStrategy: analysis.bboxStrategy ? defaults.WFS_DEFAULT_LOADING_STRATEGY : defaults.WFS_ALL_STRATEGY,
                    Declutter: true,
                    Type: layerTypes.ENTITY,
                    VisibleByDefault: true,
                    // Analiza nu trece prin _checkTemporaryVector, deci stilurile implicite se pun aici.
                    // IdDefaultStyle trebuie completat explicit: _createVectorLayer combina hover/select
                    // numai pe ramura in care el nu e null (altfel se pierd si stilurile de hover/select).
                    IdDefaultStyle: 'sys_' + styleTypes.SYSTEM_STYLE_ALL,
                    IdHighlightStyle: 'sys_' + styleTypes.SYSTEM_STYLE_HOVER_ALL,
                    IdSelectStyle: 'sys_' + styleTypes.SYSTEM_STYLE_SELECT_ALL,
                    // Fara Selectable, computeHover/computeSelection inregistreaza stratul cu active=undefined
                    // si _eligibleForInteraction il scoate din hit-test => hover/selectie moarte.
                    Selectable: true
                };

                layer.Entity.Type = 2;
                // Entitatea de analiza expune pkField, dar SelectionHandler citeste PkFieldName.
                layer.Entity.PkFieldName = analysis.pkField != null ? analysis.pkField : analysis.PkField;

                this.addLayer(layer, 0, null);
            }
        };

        return handler;
    }

    _reconstructLayerTree(nodes) {
        nodes.forEach(node => {
            this._reconstructLayerNode(node);
        });
    }

    _reconstructLayerNode(node) {
        let layer = this._findLayer(this.layers, node.Id);

        let keys = Object.keys(layer);

        keys.forEach(key => {
            if (key != 'Items') {
                node[key] = layer[key];
            }
        });

        if (node.Items != null && node.Items.length > 0) {
            this._reconstructLayerTree(node.Items);
        }
    }

    _extractLayerIds(layer, ids) {
        ids.push(layer.Id);

        if (layer.Items != null && layer.Items.length > 0) {
            layer.Items.forEach(child => {
                this._extractLayerIds(child, ids);
            });
        }
    }

    _findLayer(layers, id) {
        if (layers != null && layers.length > 0) {
            let found;
            layers.forEach(layer => {
                if (layer.Id == id) {
                    found = layer;
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    let foundChild = this._findLayer(layer.Items, id);

                    if (foundChild != null) {
                        found = foundChild;
                    }
                }
            });

            return found;
        }
    }

    _findAllLayersByGeometryFieldId(result, layers, id, idExtConn) {
        if (layers != null && layers.length > 0) {
            layers.forEach(layer => {
                if (layer.Entity != null && layer.Entity.GeometryFieldId == id && (idExtConn == '' || idExtConn == null || layer.IdExtConn == idExtConn)) {
                    result.push(layer);
                }

                if (layer.Items != null && layer.Items.length > 0) {
                    this._findAllLayersByGeometryFieldId(result, layer.Items, id, idExtConn);

                }
            });
        }
    }

    _findLayerByGeometryFieldId(layers, id, idExtConn, objectId, ignore, hasSelection) {
        if (layers != null && layers.length > 0) {
            let found;
            layers.forEach(layer => {
                if (layer.Entity != null && layer.Entity.GeometryFieldId == id && (idExtConn == '' || idExtConn == null || layer.IdExtConn == idExtConn)) {
                    if (objectId == null || objectId == '') {
                        if ((hasSelection && layer.IdSelectStyle != null) || !hasSelection) {
                            found = layer;
                        }
                    } else {
                        if ((hasSelection && layer.IdSelectStyle != null) || !hasSelection) {
                            let fullFeature = this.featureHandler.requestFeature(layer.Id, objectId, ignore);
                            if (fullFeature != null) {
                                found = layer;
                            }
                        }
                    }
                }

                if (found == null && layer.Items != null && layer.Items.length > 0) {
                    let foundChild = this._findLayerByGeometryFieldId(layer.Items, id, idExtConn, objectId, ignore, hasSelection);

                    if (foundChild != null) {
                        found = foundChild;
                    }
                }
            });

            return found;
        }
    }
}